import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalPage.css';

function LegalPage() {
  return (
    <div className="legal-page">
      <Navbar />

      <div className="legal-container">
        <div className="legal-header">
          <Link to="/" className="legal-back">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
              <path d="M19 12H5m7-7l-7 7 7 7"/>
            </svg>
            Back to Home
          </Link>
          <h1>Legal</h1>
          <p className="legal-updated">Important information about using Mindmark</p>
        </div>

        <div className="legal-hub-content">
          {/* Terms of Service */}
          <section className="legal-hub-card">
            <h2>Terms of Service</h2>
            <p className="legal-hub-summary">
              By using Mindmark, you agree to use the service responsibly and understand that it's an educational tool,
              not a substitute for professional advice. We outline your responsibilities, our subscription terms,
              and limitations of liability. <Link to="/terms" className="legal-hub-link-inline">Read full Terms of Service →</Link>
            </p>
          </section>

          {/* Privacy Policy */}
          <section className="legal-hub-card">
            <h2>Privacy Policy</h2>
            <p className="legal-hub-summary">
              We collect only essential information to provide the service - your email, usage data, and content you submit for checking.
              We don't sell your data, and payment processing is handled securely by Stripe. You can request deletion of your data at any time. <Link to="/privacy" className="legal-hub-link-inline">Read full Privacy Policy →</Link>
            </p>
          </section>

          {/* Disclaimer */}
          <section className="legal-hub-card">
            <h2>Disclaimer</h2>
            <p className="legal-hub-summary">
              Mindmark is an AI-powered assistive tool only. It does not provide legal advice and does not guarantee AHPRA compliance.
              AI has limitations and may produce inaccurate results. Always verify findings independently and consult qualified professionals
              for definitive compliance guidance. <Link to="/disclaimer" className="legal-hub-link-inline">Read full Disclaimer →</Link>
            </p>
          </section>
        </div>

        <div className="legal-hub-contact">
          <h3>Questions?</h3>
          <p>
            If you have any questions about our legal policies, please contact us at{' '}
            <a href="mailto:support@mindmark.au">support@mindmark.au</a>
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default LegalPage;
